import { Routes, Route } from 'react-router-dom'
import { motion } from 'framer-motion'
import { useState } from 'react'
import { Menu } from 'lucide-react'

// Components
import Sidebar from './components/Sidebar'
import HomePage from './pages/HomePage'
import MarketsPage from './pages/MarketsPage'
import MarketDetailPage from './pages/MarketDetailPage'
import CreateMarketPage from './pages/CreateMarketPage'
import ProfilePage from './pages/ProfilePage'
import FantasyFootballPage from './pages/FantasyFootballPage'
import FantasyContestDetailPage from './pages/FantasyContestDetailPage'
import FantasyLandingPage from './pages/FantasyLandingPage'
import FantasyQuickBuildPage from './pages/FantasyQuickBuildPage'
import CreateAgiEventPage from './pages/CreateAgiEventPage'

// Hooks and stores
import { useAuthStore } from './store/authStore'

function App() {
  const { user, isLoading } = useAuthStore()
  const [sidebarOpen, setSidebarOpen] = useState(true)

  if (isLoading) {
    return (
      <div className="min-h-screen bg-[#001a3d] flex items-center justify-center">
        <div className="text-center">
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
            className="w-8 h-8 border-2 border-[#2AAAEA] border-t-transparent rounded-full mx-auto mb-4"
          />
          <p className="text-gray-400">Loading CPX...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-[#001a3d] flex">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      
      {/* Hamburger Menu Button - shows when sidebar is closed */}
      {!sidebarOpen && (
        <button
          onClick={() => setSidebarOpen(true)}
          className="fixed top-4 left-4 z-50 w-12 h-12 bg-[#052393] hover:bg-[#2AAAEA] text-white rounded-lg flex items-center justify-center shadow-lg transition-all"
          aria-label="Open sidebar"
        >
          <Menu className="w-6 h-6" />
        </button>
      )}
      
      {/* Main content area with dynamic margin and padding */}
      <main className={`${sidebarOpen ? 'ml-60' : 'ml-0 pl-20'} flex-1 min-h-screen transition-all duration-300`}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/markets" element={<MarketsPage />} />
          <Route path="/markets/:id" element={<MarketDetailPage />} />
          <Route path="/create" element={<CreateMarketPage />} />
          <Route path="/create/agi-event" element={<CreateAgiEventPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/fantasy" element={<FantasyLandingPage />} />
          <Route path="/fantasy/quick" element={<FantasyQuickBuildPage />} />
          <Route path="/fantasy/custom" element={<FantasyFootballPage />} />
          <Route path="/fantasy/create" element={<FantasyFootballPage />} />
          <Route path="/fantasy/:id" element={<FantasyContestDetailPage />} />
        </Routes>
      </main>

      {/* Background decorations - CPX brand colors */}
      <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-[#2AAAEA]/10 rounded-full blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-[#009245]/10 rounded-full blur-3xl" />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-[#FBB03B]/5 rounded-full blur-3xl" />
      </div>
    </div>
  )
}

export default App

